import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "./HistoryLogs.css"; // Import the CSS file

const HistoryLogsHeaderComponent = ({
  globalFilterValue,
  onGlobalFilterChange,
  clearFilter,
}) => {
  return (
    <div className="flex justify-content-between header-container">
      <div className="flex search-container">
        <IconField iconPosition="right" className="search-field">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
            style={{ fontFamily: "poppins" }}
            className="search-input"
          />
        </IconField>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Clear"
          outlined
          onClick={clearFilter}
          className="clear-button"
          style={{
            backgroundColor: "#D97A07",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            fontFamily: "poppins",
          }}
        />
      </div>
    </div>
  );
};

export default HistoryLogsHeaderComponent;
